import Swiper from 'swiper';
import {Navigation, Pagination, Thumbs, Autoplay, Keyboard} from 'swiper/modules';
Swiper.use([Navigation, Pagination, Thumbs, Autoplay, Keyboard]);
window.Swiper = Swiper;
